import { render, staticRenderFns } from "./BuildingEmergency.vue?vue&type=template&id=769903e4&scoped=true&"
import script from "./BuildingEmergency.vue?vue&type=script&lang=js&"
export * from "./BuildingEmergency.vue?vue&type=script&lang=js&"
import style0 from "./BuildingEmergency.vue?vue&type=style&index=0&id=769903e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769903e4",
  null
  
)

export default component.exports